import Logo from './assets/najdioudlogoS.jpeg';
import './App.css';
import Home from './pages/Home';

function App() {
  return (
    <Home />
  );
}

export default App;
